import { GenericClassTranslate } from './genericClass';

export class PendingSignStatus extends GenericClassTranslate {
}

export enum PendingSignStatusEnum {
    PENDING = 1,
    SIGNED = 2
}
